import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { ANALYTICS_REPORTS_ACTION_TYPE } from '../actions';

const initialState = {
  companyReports: [],
  userReports: [],
  reportEmbedLink: null,
};

const reportsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case ANALYTICS_REPORTS_ACTION_TYPE.GET_COMPANY_REPORTS:
      case ANALYTICS_REPORTS_ACTION_TYPE.SET_SELECTED_REPORTS_BY_ROLE:
        draft.companyReports = payload;
        break;

      case ANALYTICS_REPORTS_ACTION_TYPE.GET_USER_REPORTS:
        draft.userReports = payload;
        break;

      case ANALYTICS_REPORTS_ACTION_TYPE.GET_REPORT_EMBED_LINK:
        draft.reportEmbedLink = payload;
        break;

      case RESET_STATE:
      case ANALYTICS_REPORTS_ACTION_TYPE.RESET_REPORTS_STATE:
        return initialState;

      default:
        break;
    }
  });

export default reportsReducer;
